(function () {
  function closePicker(picker) {
    if (!picker) return;

    var dropdown = picker.querySelector('[data-variant-picker-dropdown]');
    var trigger = picker.querySelector('[data-variant-picker-trigger]');

    picker.classList.remove('is-open');

    if (dropdown) {
      dropdown.hidden = true;
    }

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  function openPicker(picker) {
    if (!picker) return;

    var dropdown = picker.querySelector('[data-variant-picker-dropdown]');
    var trigger = picker.querySelector('[data-variant-picker-trigger]');

    picker.classList.add('is-open');

    if (dropdown) {
      dropdown.hidden = false;
    }

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeAllPickers(exceptPicker) {
    document.querySelectorAll('[data-variant-picker].is-open').forEach(function (picker) {
      if (picker !== exceptPicker) {
        closePicker(picker);
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var option = event.target.closest('[data-variant-option]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();

        if (option.disabled) {
          return;
        }

        var picker = option.closest('[data-variant-picker]');
        if (!picker) {
          return;
        }

        var hiddenInput = picker.querySelector('[data-variant-picker-input]');
        var currentPrice = picker.querySelector('[data-variant-picker-current-price]');
        var currentTitle = picker.querySelector('[data-variant-picker-current-title]');
        var options = picker.querySelectorAll('[data-variant-option]');

        options.forEach(function (item) {
          item.classList.remove('is-active');
        });

        option.classList.add('is-active');

        if (hiddenInput) {
          hiddenInput.value = option.getAttribute('data-variant-id') || '';
        }

        if (currentPrice) {
          currentPrice.innerHTML = option.getAttribute('data-variant-price') || '';
        }

        if (currentTitle) {
          currentTitle.textContent = option.getAttribute('data-variant-title') || '';
        }

        closePicker(picker);
        return;
      }

      var trigger = event.target.closest('[data-variant-picker-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        var picker = trigger.closest('[data-variant-picker]');
        if (!picker) {
          return;
        }

        var isOpen = picker.classList.contains('is-open');

        closeAllPickers(picker);

        if (isOpen) {
          closePicker(picker);
        } else {
          openPicker(picker);
        }

        return;
      }

      document.querySelectorAll('[data-variant-picker].is-open').forEach(function (picker) {
        if (!picker.contains(event.target)) {
          closePicker(picker);
        }
      });
    },
    true
  );
})();